<div class="form-control" *ngIf="shown">
  <p *ngIf="title" class="form-control__title body-bold">
    {{ title }}
  </p>

  <p *ngIf="description" class="form-control__description">
    {{ description }}
  </p>

  <label
    class="form-control__label"
    [class.form-control__label--disabled]="disabled"
    [class.form-control__label--error]="hasError"
    [class.form-control__label--horizontal]="isHorizontal"
  >
    <span class="form-control__label__text">
      {{ labelDisplayed }}
      <ng-content select="[custom-label]"></ng-content>
    </span>

    <ng-container *ngIf="!isExternalLabel">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-container>
  </label>

  <ng-container *ngIf="isExternalLabel">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </ng-container>

  <div class="form-control__indications">
    <ng-container *ngIf="errorMessages?.length">
      <span
        *ngFor="let message of errorMessages || []"
        class="form-control__indications__error"
      >
        <vtmn-play-icon
          [name]="errorIconName"
          class="form-control__indications__error__icon"
        ></vtmn-play-icon>
        {{ message }}
      </span>
    </ng-container>
  </div>

  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>
</div>
